<template>
  <div>
    <b-modal id="modal_upload_file_decret" hide-footer>
      <template #modal-title>
        Cargar Productos con archivo Excel
      </template>

      <b-alert show variant="warning">Solo los productos que tengan <i class="font-weight-bold">cantidad comprada kg </i> superior a 0 seran tenidos en cuenta para la importación</b-alert>

      <div class="mt-1 mb-4">
        <b-form-file accept=".xlsx, .xls" v-model="file" :state="Boolean(file)"
                     placeholder="Elija un archivo o suéltelo aquí..."
                     drop-placeholder="Suelta el archivo aquí..."></b-form-file>
        <div class="mt-3 font-weight-bold">Documento seleccionado: {{ file ? file.name : 'Ninguno' }}</div>
      </div>

      <div class="d-flex justify-content-end align-items-center">
        <b-button @click="closeModal">
          <i class="fa fa-close fa-lg"></i>
          <span class="ml-1"> Cancelar</span>
        </b-button>
        <b-button variant="primary" class="ml-2" @click="loadFile">
          <i class="fa fa-upload fa-lg"></i>
          <span class="ml-1"> Guardar información</span>
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>

import Swal from 'sweetalert2'
import {mapActions, mapState} from "vuex";
import {getAcls} from '../../plugins/acl';
import {uploadFileWProductsImported} from "@/servicios/decret_1630/actions";

export default {
  name: "ModalLoadFile",
  props: ['showProccessBackground'],
  data() {
    return {
      file: null
    }
  },
  created() {
    this.file = null;
  },
  methods: {
    ...mapActions("decret_1630", ["uploadFileWProductsImported","loadProccessBackground"]),
    loadFile() {
      const acls = getAcls();
      const typeFileValids = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel'
      ];

      if (!this.file) {
        this.openAlertInfoError('No has seleccionado ningún archivo.');
        return false;
      }

      if (!typeFileValids.includes(this.file.type)) {
        this.openAlertInfoError('El tipo de archivo seleccionado no está permitido, recuerda que debe ser del tipo aplicación Excel. (.xls, .xlsx)');
        this.file = null;
        return false;
      }

      const formData = new FormData();
      formData.append('file', this.file);
      formData.append('company_id', this.filtro.empresa);
      if (acls && acls.uuid) {
        formData.append('uuid', acls.uuid);
      }

      this.uploadFileWProductsImported(formData).then(async ({message}) => {
        this.closeModal();
        await Swal.fire({
          position: 'center',
          icon: 'success',
          title: message,
          showConfirmButton: false,
          timer: 2000
        });
        this.$bvModal.show('modal_process_background');
        await this.loadProccessBackground({company_id: this.filtro.empresa, type: 'INVENTARIO-PRODUCTOS-DECRETO-1630'});

      }).catch(async (message) => {
        await Swal.fire({
          position: 'center',
          icon: 'error',
          title: message,
          showConfirmButton: false,
          timer: 2000
        });
      });
    },
    // control de alertas erroneas
    openAlertInfoError(message) {
      Swal.fire({
        position: 'center',
        icon: 'info',
        title: message,
        showConfirmButton: true
      })
    },
    // cerrar modales
    closeModal() {
      this.$bvModal.hide('modal_upload_file_decret');
      this.file = null;
    }
  },
  computed: {
    ...mapState('productos', ['filtro']),
  }
}

</script>

<style scope>
.custom-file-label::after {
  content: 'Seleccionar' !important;
}
</style>
